var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ScreeningsUpdateFirstSteps"},[_c('div',{staticClass:"List"},[(!_vm.projectType)?_c('router-link',{staticClass:"FirstStepLink",attrs:{"to":{
        name: 'ScreeningsUpdateProjectDetails',
        params: { screeningID: this.$route.params.screeningID }
      }}},[_c('ProjectOptionListItem',{attrs:{"item":_vm.projectDetailsItem}})],1):_vm._e(),(!_vm.noOfSelectedUnits)?_c('router-link',{staticClass:"FirstStepLink",attrs:{"to":{
        name: 'ScreeningsUpdateBuildings',
        params: { screeningID: this.$route.params.screeningID }
      }}},[_c('ProjectOptionListItem',{attrs:{"item":_vm.unitsItem}})],1):_vm._e()],1)])}
var staticRenderFns = []

export { render, staticRenderFns }